var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128006(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-006-1{fill:#fff;}.cls-128-006-2{fill:none;stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-006-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-006-2",
    x: 11.52,
    y: 24.98,
    width: 104.97,
    height: 76.95,
    rx: 3.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-128-006-2",
    points: "25.23 40.77 25.23 32.87 109.95 32.87 109.95 94.04 25.23 94.04 25.23 87.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-006-2",
    d: "M99,71.16,95.75,63A3.74,3.74,0,1,0,93,63l-3.28,8.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128-006-2",
    points: "23.91 113.05 19.03 113.05 22.02 102.05 29.96 102.05 23.91 113.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128-006-2",
    points: "105.07 113.05 109.95 113.05 106.96 102.05 99.02 102.05 105.07 113.05"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-006-2",
    x: 20.16,
    y: 54.52,
    width: 10.14,
    height: 5.15,
    rx: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-006-2",
    x: 20.16,
    y: 40.77,
    width: 10.14,
    height: 5.15,
    rx: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-006-2",
    x: 20.16,
    y: 68.27,
    width: 10.14,
    height: 5.15,
    rx: 1.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-006-2",
    x: 20.16,
    y: 82.03,
    width: 10.14,
    height: 5.15,
    rx: 1.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-006-2",
    d: "M81.4,65.72V61.2H74.93a14.82,14.82,0,0,0-2.7-6.52l4.58-4.57-3.2-3.2L69,51.49a14.67,14.67,0,0,0-6.51-2.7V42.32H58v6.47a14.67,14.67,0,0,0-6.51,2.7l-4.58-4.58-3.2,3.2,4.58,4.57a14.71,14.71,0,0,0-2.7,6.52H39.12v4.52h6.47a14.79,14.79,0,0,0,2.7,6.51l-4.58,4.58L46.91,80l4.58-4.57A14.77,14.77,0,0,0,58,78.12V84.6h4.52V78.12A14.77,14.77,0,0,0,69,75.43L73.61,80l3.2-3.19-4.58-4.58a14.79,14.79,0,0,0,2.7-6.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-006-2",
    cx: 60.26,
    cy: 63.46,
    r: 10.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-006-2",
    x1: 25.23,
    y1: 45.92,
    x2: 25.23,
    y2: 54.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-006-2",
    x1: 25.23,
    y1: 59.7,
    x2: 25.23,
    y2: 68.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-006-2",
    x1: 25.23,
    y1: 73.6,
    x2: 25.23,
    y2: 82
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128006);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_006.c618125f809f6999c917162bbbe8ecef.svg";
export { ForwardRef as ReactComponent };